import { render, staticRenderFns } from "./IeModal.vue?vue&type=template&id=3a71e396"
import script from "./IeModal.vue?vue&type=script&lang=js"
export * from "./IeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports